import { Provider } from '@angular/core';
import { PublicationsDataHttpService } from './abstract';
import { PublicationsDataHttpServiceImpl } from './publications-data-http.service';

export const PublicationsDataHttpProvider: Provider = {
	provide: PublicationsDataHttpService,
	useClass: PublicationsDataHttpServiceImpl,
};
